<template>
  <div
    class="iframe-container"
    :class="{ active: isActive }"
    :style="{ top: y + 'px', left: x + 'px', zIndex: zIndex, width: width + 'px', height: height + 'px' }"
    @mousedown="onMouseDown"
  >
    <div style="position:absolute; top: 8px; left: 8px; color: #e32323">live</div>
    <button class="close-btn" @click="$emit('close')">✕</button>
    <iframe :src="src" allow="autoplay; fullscreen; camera; microphone"></iframe>
    <div class="resize-handle-right" @mousedown.stop="onResizeStart('right', $event)"></div>
    <div class="resize-handle-left" @mousedown.stop="onResizeStart('left', $event)"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps, defineEmits } from 'vue'

const props = defineProps({
  src: String,
  zIndex: Number,
})

const emit = defineEmits(['close', 'bringToFront'])

const x = ref(Math.random() * (window.innerWidth - 350))
const y = ref(Math.random() * (window.innerHeight - 220))
const width = ref(320)
const height = ref(180)
const isActive = ref(false)

let dragOffsetX = 0
let dragOffsetY = 0
let resizing = null
let startX = 0
let startY = 0
let startW = 0
let startH = 0
let startPosX = 0
let aspectRatio = 16 / 9

const onMouseDown = (e) => {
  if (e.target.classList.contains('close-btn') ||
      e.target.classList.contains('resize-handle-right') ||
      e.target.classList.contains('resize-handle-left')) return

  isActive.value = true
  dragOffsetX = e.clientX - x.value
  dragOffsetY = e.clientY - y.value
  emit('bringToFront')
}

const onResizeStart = (direction, e) => {
  resizing = direction
  startX = e.clientX
  startY = e.clientY
  startW = width.value
  startH = height.value
  startPosX = x.value // save current x position for left/bottom-left
  aspectRatio = width.value / height.value
}

const onMouseMove = (e) => {
  if (isActive.value && !resizing) {
    x.value = e.clientX - dragOffsetX
    y.value = e.clientY - dragOffsetY
  }

  if (resizing) {
    const dx = e.clientX - startX

    if (resizing === 'right') {
      let newWidth = startW + dx
      let newHeight = newWidth / aspectRatio

      if (x.value + newWidth > window.innerWidth) newWidth = window.innerWidth - x.value
      if (y.value + newHeight > window.innerHeight) newHeight = window.innerHeight - y.value

      width.value = newWidth
      height.value = newHeight
    }

    if (resizing === 'left') {
      let newWidth = startW - dx
      let newHeight = newWidth / aspectRatio

      if (startPosX + dx < 0) newWidth = startW + startPosX
      if (y.value + newHeight > window.innerHeight) newHeight = window.innerHeight - y.value

      width.value = newWidth
      height.value = newHeight
      x.value = startPosX + dx
    }
  }
}

const onMouseUp = () => {
  isActive.value = false
  resizing = null
}

onMounted(() => {
  document.addEventListener('mousemove', onMouseMove)
  document.addEventListener('mouseup', onMouseUp)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousemove', onMouseMove)
  document.removeEventListener('mouseup', onMouseUp)
})
</script>

<style scoped>
.iframe-container {
  position: fixed;
  border: 0.01px solid rgba(143, 140, 140, 0.349);
  border-radius: 10px;
  overflow: hidden;
  background: none;
  cursor: move;
  box-shadow: 0 4px 8px rgba(143, 140, 140, 0.349);
  resize: none;
}

.iframe-container.active {
  border-color:#0078ff;
}

.iframe-container:hover {
  border-top: 10px solid;
  border-left: 10px solid;
  border-right: 10px solid
}

.close-btn {
  position: absolute;
  top: 0px;
  right: 6px;
  background: none;
  color: rgba(0, 0, 0, 0.3);
  border: none;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.6);
  color: white;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.resize-handle-right,
.resize-handle-left {
  position: absolute;
  width: 16px;
  height: 16px;
  bottom: 0;
  border-radius: 3px;
  cursor: se-resize;
  z-index: 20;
}

.resize-handle-left {
  left: 0;
  cursor: sw-resize;
}

.resize-handle-right {
  right: 0;
}
</style>
